import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const COLORS = { none:'#00C2A8', quarantine:'#F5A623', reject:'#E8415A' };

const card = {
  background: 'rgba(30,45,79,0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(0,194,168,0.1)',
  padding: '24px',
};

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { name, value } = payload[0];
  return (
    <div style={{ background:'#1E2D4F', border:'1px solid rgba(0,194,168,0.3)', borderRadius:'8px', padding:'10px 14px' }}>
      <div style={{ fontFamily:'Space Grotesk', fontSize:'13px', color:COLORS[name] || '#F0F4FF', textTransform:'capitalize', fontWeight:600 }}>{name}</div>
      <div style={{ fontFamily:'JetBrains Mono', fontSize:'13px', color:'#F0F4FF' }}>{value.toLocaleString()} emails</div>
    </div>
  );
}

export default function DispositionChart({ dispositions }) {
  const data = Object.entries(dispositions)
    .filter(([, v]) => v > 0)
    .map(([k, v]) => ({ name: k, value: v }));

  if (!data.length) return null;

  return (
    <div style={card}>
      <div style={{ marginBottom:'16px' }}>
        <div style={{ fontFamily:'Space Grotesk', fontWeight:600, fontSize:'16px', color:'#F0F4FF' }}>Policy Disposition</div>
        <div style={{ fontFamily:'Inter', fontSize:'12px', color:'#5B7BA8', marginTop:'4px' }}>How receiving servers handled your email</div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" innerRadius={55} outerRadius={80} dataKey="value" paddingAngle={3}>
            {data.map((entry) => (
              <Cell key={entry.name} fill={COLORS[entry.name] || '#5B7BA8'} stroke="transparent" />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend formatter={(v) => <span style={{ fontFamily:'Space Grotesk', fontSize:'13px', color:'#7B9CC8', textTransform:'capitalize' }}>{v}</span>} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
